import {authAPI} from "../API_DAL/api_dal";
import {stopSubmit} from "redux-form";

const SET_MY_DATA = "auth/SET_MY_DATA";
const ACTIVE_PAGE_SITE = "auth/ACTIVE_PAGE_SITE";
const TOGGLE_PRELOADER = "auth/TOGGLE_PRELOADER";
const SET_CAPTCHA = "auth/SET_CAPTCHA";

const initialState = {
    id: null,
    email: null,
    login: null,
    isAuth: false,
    activePageSite: null,
    isPreloader: false,
    captcha: null,
    authorizationError: false
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MY_DATA:
            return {
                ...state,
                ...action.data,
                isAuth: action.isAuth
            };
        case ACTIVE_PAGE_SITE:
            return {
                ...state,
                activePageSite: action.page
            };
        case TOGGLE_PRELOADER:
            return {
                ...state,
                isPreloader: action.isPreloader
            };
        case SET_CAPTCHA:
            return {
                ...state,
                captcha: action.captcha
            };
        default:
            return state;
    }
};

const setMyData = (data, isAuth) => ({type: SET_MY_DATA, data, isAuth});
export const setActivePageSite = (page) => ({type: ACTIVE_PAGE_SITE, page});
export const togglePreloader = (isPreloader) => ({type: TOGGLE_PRELOADER, isPreloader});
export const setCaptcha = (captcha) => ({type: SET_CAPTCHA, captcha});

export const getMyData = () => (dispatch) => {
    return authAPI.me().then(data => {
        if (data.resultCode === 0)
            dispatch(setMyData(data.data, true));
    })
};

export const loginMe = (formData) => (dispatch) => {
    debugger
    authAPI.login(formData).then(data => {
        if (data.resultCode === 0)
            dispatch(getMyData());
        else if (data.resultCode === 10) {
            authAPI.captcha().then(data => {
                dispatch(setCaptcha(data.url))
            })
        }
        else {
            let message = data.messages.length > 0 ? data.messages[0] : "Неизвестная ошибка";
            dispatch(stopSubmit('login', {_error: message}))
        }
    })
};

export const logOutMe = () => (dispatch) => {
    dispatch(togglePreloader(true));
    authAPI.logOut().then(data => {
        dispatch(setMyData({id: null, email: null, login: null}, false));
        dispatch(togglePreloader(false))
    })
};



export default authReducer;